import { useState } from 'react'
import { useRouter } from 'next/router'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useSocket from 'tennders-common/hooks/useSocket'
import { apiPut } from 'tennders-stracture/libs/api'
import { STATUS_WAITING_FOR_OFFER } from 'tennders-stracture/libs/constants'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { useToast } from 'tennders-common/hooks/useToast'
import useSession from 'tennders-auth/hooks/useSession'

export const withSharedNegotiation = (WrappedComponent) => ({ transaction, ...rest }) => {
  const [submitting, setsubmitting] = useState(false)
  const { toastSuccess, toastError } = useToast()
  const { refreshTransaction } = useTransactions()
  const { transaction: openedTransaction, setTransaction } = useTransaction()

  const { setRefresh } = useSocket()
  const { isBroker } = useSession()
  const router = useRouter()
  const { makeOffer, errors, acceptOffer } = useOffer()

  const continueNegotiate = async () => {
    setsubmitting(true)
    await apiPut(`offers/${transaction?.id}/continue`, {})
    setsubmitting(false)
    setRefresh('offers')
  }

  const revertOffers = async () => {
    setsubmitting(true)
    await apiPut(`offers/${transaction?.id}/revert`, {})
    setsubmitting(false)
    setRefresh('fast')
    setRefresh('offers')
    refreshTransaction()
  }

  const acceptMPOffer = async (offer) => {
    setsubmitting(true)
    let response = null
    if (offer?.lastOffer?.id || offer?.id) {
      response = await acceptOffer(offer?.lastOffer?.id || offer?.id)
    } else {
      response = await apiPut(`offers/direct-accept/${transaction?.id}`, {
        transaction: transaction?.id,
        owner: offer?.createdBy?.id
      })
    }
    setsubmitting(false)
    if (response?.error) {
      toastError(response.error)
      return
    }
    if (openedTransaction) {
      setRefresh('offers')
      setTimeout(() => {
        setRefresh('all')
      }, 3000)
    } else {
      setRefresh('all')
    }
    if (isBroker()) {
      toastSuccess('Congrats,offer accepted and pair is assigned')
      // router.push('/qc/transactions')
    } else {
      toastSuccess('Congrats, we will let broker know that you accepted the offer')
    }
  }

  const assignOffer = async (offer) => {
    setsubmitting(true)
    let response = null
    if (offer?.lastOffer?.id || offer?.id) {
      response = await apiPut(`offers/${offer?.lastOffer?.id}/assign`,
        { id: offer?.lastOffer?.id || offer?.id })
    } else {
      response = await apiPut(`offers/${transaction?.id}/assign-direct/${offer?.createdBy?.id}`,
        { id: offer?.createdBy?.id })
    }
    if (response?.id) {
      openedTransaction(response.id)
    }
    setsubmitting(false)
    if (response.error) {
      toastError(response.error)
      return
    }
    if (openedTransaction) {
      setRefresh('offers')
      setTimeout(() => {
        setRefresh('all')
      }, 3000)
    } else {
      setRefresh('all')
    }
    if (isBroker()) {
      toastSuccess('Congrats, pair is assigned')
      setTransaction(false)
      router.push('/qc/transactions')
    } else {
      toastSuccess('Congrats, pair is assigned')
    }
  }

  const declineMPOffer = async (offer) => {
    setsubmitting(true)
    const response = await apiPut(`offers/direct-decline/${transaction?.id}`, {
      transaction: transaction?.id,
      offer: offer?.id,
      owner: offer?.createdBy?.id
    })
    setsubmitting(false)
    if (response.error) {
      toastError(response.error)
      return
    }
    if (!isBroker()) {
      toastSuccess('We have removed this offer from your board. If you want it back, you can contact with Tennders to share it again')
    } else {
      toastSuccess('We have declined and removed sharing this offer with this user')
    }
    if (openedTransaction) {
      setRefresh('offers')
      setTimeout(() => {
        setRefresh('all')
      }, 2000)
    } else {
      setRefresh('fast')
    }
  }

  const sendBid = async (form) => {
    setsubmitting(true)
    const params = {
      ...form,
      bid: form?.bid || form?.marketPaymentTerms?.marketPrice,
      transaction: transaction?.id
    }
    const response = await makeOffer(transaction, params)
    setsubmitting(false)
    if (rest.onClose) {
      rest.onClose()
    }
    if (response?.id) {
      if (openedTransaction) {
        setRefresh('offers')
        setTimeout(() => {
          setRefresh('all')
        }, 3000)
      } else {
        setRefresh('fast')
      }
      toastSuccess('Offer is sent')
      if (transaction?.status?.label === STATUS_WAITING_FOR_OFFER) {
        refreshTransaction()
      }
    }
  }

  return (
    <WrappedComponent
      transaction={transaction}
      sendBid={sendBid}
      assignOffer={assignOffer}
      acceptOffer={acceptMPOffer}
      declineOffer={declineMPOffer}
      errors={errors}
      continueNegotiate={continueNegotiate}
      revertOffers={revertOffers}
      submitting={submitting}
      {...rest}
    />
  )
}
